export enum QUERY_KEYS {
  PROJECT = 'PROJECT',
  PROJECTS = 'PROJECTS',
}

export default QUERY_KEYS
